"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMemberAchievementList = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Returns a list of all badges belonging to a member.
 * Member can be identified by either Discord ID or Steam ID, but at least one of those values **must** be provided.
 *
 * ### Filter options
 *
 * - `gameId` - filters by ID of the Steam game the badge belongs to,
 *
 * ### Sort options
 *
 * - `unlockTime` - sorts by badge's point value.
 *
 * ## Usage
 *
 * ```ts
 * const steamId: string = "567876545678";
 *
 * const memberAchievements: MemberAchievement[] =
 *   await sdk.getMemberAchievementList({ steamId });
 * const memberAchievementsFromNewest: MemberAchievement[] =
 *   await sdk.getMemberAchievementList({ steamId, sort: { unlockTime: 'desc' }});
 * const memberAchievementsByGame: MemberAchievement[] =
 *   await sdk.getMemberAchievementList({ steamId, filter: { gameId: '666' }});
 * ```
 *
 * @param params.steamId   - (Optional) Steam ID of the requested member.
 * @param params.discordId - (Optional) Discord ID of the requested member.
 * @param params.filter    - Filter to apply to returned achievement list.
 * @param params.sort      - Fields to sort achievement list by.
 * @param params.limit     - How many achievements will get returned.
 */
const getMemberAchievementList = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { steamId, discordId, filter, sort, limit } = params;
    const memberId = steamId !== null && steamId !== void 0 ? steamId : discordId;
    const url = `${BASE_URL}/members/member/${memberId}/achievements/list`;
    const memberAchievementListResponse = yield axios_1.default.post(url, { filter, sort, limit }, { validateStatus: () => true });
    const { status, data } = memberAchievementListResponse;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.getMemberAchievementList = getMemberAchievementList;
